import './MessageCloud.scss';

import React, { useMemo } from 'react'
import { ChatMessage } from '../../models/LLM'
import classNames from 'classnames';
import MDEditor from '@uiw/react-md-editor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Collapse } from 'antd';
import { calcResponseTime } from '../../utils';

type Props = {
  message?: ChatMessage;
  children?: React.ReactNode;
}

export default function MessageCloud({ message, children }: Props) {
  const messageContent = useMemo(() => children || message?.text || "", [message, children]);

  return (
    <div className={classNames("message-cloud", message?.kind, message?.role)}>
      {typeof messageContent === 'object'
        ? messageContent
        : message?.isAlert
          ? (
            <div className="text-danger">
              <FontAwesomeIcon icon={solid('exclamation-circle')} />
              <span className="ms-1">{messageContent}</span>
            </div>
          )
          : (message?.kind === "reasoning" || message?.kind === "tool") && message.time?.end
            ? (
              <Collapse
                bordered={false}
                items={[
                  {
                    label: <span className="text-capitalize">{message.kind} - {calcResponseTime(message.time)}s</span>,
                    children: (
                      <div data-color-mode="light">
                        <MDEditor.Markdown className="bg-transparent" source={messageContent} />
                      </div>
                    )
                  }
                ]}
              />
            )
            : (
              <div data-color-mode="light">
                <MDEditor.Markdown className="bg-transparent" source={messageContent} />
              </div>
            )
      }
    </div>
  )
}